// extracted by mini-css-extract-plugin
export default {"your_rd":"Tr","title":"Ur","subtitle":"Vr","rd_bio_wrapper":"Wr","rd_text_mobile":"Xr","rd_bio":"Yr","img":"Zr","rd_info":"as","rd_name":"bs","rd_stat":"cs","rd_text":"es","btn_mobile":"fs"};
    if(module.hot) {
      // 1714654883861
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  